// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"86a8d406","455":"b71025bf","977":"5dca7924"}[chunkId] + ".chunk.js";
};